const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgCoopeuch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "faab3365-dc13-48a2-9b5f-ee704dee2393",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a17a9367-0e34-47cf-a3f4-2af481e88559{fill:#f7202b;}.b21caae6-4c8f-43ff-9324-ece3103d413b{fill:#fff;}")), /*#__PURE__*/React.createElement("rect", {
    className: "a17a9367-0e34-47cf-a3f4-2af481e88559",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "b21caae6-4c8f-43ff-9324-ece3103d413b",
    d: "M17,41H14.74l-.29,0a3.41,3.41,0,0,1-2.79-2.64c0-.18-.07-.37-.1-.56v-16a2.58,2.58,0,0,0,0-.29,10.66,10.66,0,0,1,.32-2.1,11,11,0,0,1,4.74-6.67,9.88,9.88,0,0,1,4.6-1.6L21.9,11H37.32l.26.05a3.41,3.41,0,0,1,2.76,2.62c0,.19.07.39.1.58v2.43a.62.62,0,0,1-.59.45c-.61,0-1.23.07-1.85.13a20.12,20.12,0,0,0-4.2.88A22.64,22.64,0,0,0,23,25.48a24.05,24.05,0,0,0-5.52,14.78C17.45,40.63,17.35,40.89,17,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b21caae6-4c8f-43ff-9324-ece3103d413b",
    d: "M24.92,41c-.47-.19-.53-.29-.5-.91a16.9,16.9,0,0,1,6.92-12.81,15.15,15.15,0,0,1,6.48-2.72c.65-.11,1.32-.15,2-.22a.59.59,0,0,1,.6.38,1,1,0,0,1,0,.1v12.9c0,.13,0,.26-.07.4a3.46,3.46,0,0,1-2.6,2.78l-.54.1Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoopeuch);
export default __webpack_public_path__ + "static/media/COOPEUCH.0125104372d2907f727aac78afc9c5ca.svg";
export { ForwardRef as ReactComponent };